var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocbuyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 144,
    viewBox: "0 0 181 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.3036 9.09082C59.7107 9.09082 41.3945 27.4069 41.3945 49.9999C41.3945 72.5929 59.7107 90.909 82.3036 90.909C104.897 90.909 123.213 72.5929 123.213 49.9999C123.213 27.4069 104.897 9.09082 82.3036 9.09082ZM106.023 55.5486H90.634C89.0999 55.5486 87.8523 56.7963 87.8523 58.3303V73.7191H76.75V58.3303C76.75 56.7963 75.5024 55.5486 73.9684 55.5486H58.5795V44.4463H73.9684C75.5024 44.4463 76.75 43.1987 76.75 41.6647V26.2758H87.8523V41.6647C87.8523 43.1987 89.0951 44.4463 90.634 44.4463H106.023V55.5486Z",
    fill: "#6BE4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9705 55.5486H58.5816V44.4463C44.1443 44.4463 43.1055 61.7284 43.1055 61.7284C51.5621 88.307 76.757 90.5303 76.757 90.5303V58.3303C76.757 56.7962 75.5094 55.5486 73.9754 55.5486H73.9705Z",
    fill: "url(#paint0_linear_590_18258)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9676 44.4465C75.5017 44.4465 76.7493 43.1989 76.7493 41.6649V26.276H87.8516C87.8516 11.8387 70.5695 10.7998 70.5695 10.7998C43.9909 19.2564 41.7676 44.4514 41.7676 44.4514H73.9676V44.4465Z",
    fill: "url(#paint1_linear_590_18258)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8525 9.46484V26.2761V41.6649C87.8525 43.199 89.0953 44.4466 90.6341 44.4466H106.023V55.5489C120.46 55.5489 121.499 38.2668 121.499 38.2668C113.043 11.6882 87.8477 9.46484 87.8477 9.46484H87.8525Z",
    fill: "url(#paint2_linear_590_18258)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.023 55.5488H90.6339C89.0999 55.5488 87.8523 56.7964 87.8523 58.3305V73.7193H76.75C76.75 88.1566 94.0321 89.1955 94.0321 89.1955C120.611 80.7389 122.834 55.5439 122.834 55.5439H106.023V55.5488Z",
    fill: "url(#paint3_linear_590_18258)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1592 112H26.2067C33.0106 112 38.2335 116.635 38.2335 124.873C38.2335 133.112 33.0106 137.747 26.2067 137.747H17.1592V112ZM26.2067 136.091C31.7243 136.091 36.1738 132.267 36.1738 124.873C36.1738 117.48 31.7231 113.692 26.2067 113.655H19.0715V136.091H26.2067Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8809 127.632C40.8809 121.012 45.2572 117.187 50.6641 117.187C56.0709 117.187 60.4472 121.011 60.4472 127.632C60.4472 134.254 56.0709 138.078 50.6641 138.078C45.2572 138.078 40.8809 134.254 40.8809 127.632ZM58.4984 127.632C58.4984 122.042 55.0782 118.805 50.6641 118.769C46.2499 118.732 42.8297 122.042 42.8297 127.632C42.8297 133.223 46.2499 136.534 50.6641 136.497C55.0782 136.459 58.4984 133.223 58.4984 127.632Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1328 127.596C63.1328 121.453 66.7735 117.187 72.916 117.187C78.5068 117.187 81.5591 120.828 82.0013 125.241H80.0524C79.7954 121.785 77.2936 118.768 72.9172 118.768C68.0622 118.768 65.0829 122.409 65.0829 127.595C65.0829 133.074 68.5031 136.496 72.9172 136.496C77.3314 136.496 79.648 133.149 80.0524 130.426H82.0013C81.486 134.436 78.3228 138.077 72.916 138.077C67.0683 138.077 63.1328 133.921 63.1328 127.595V127.596Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.053 130.501C109.053 135.024 105.229 137.747 100.52 137.747H90.001V112H100.079C103.867 112 107.214 114.391 107.214 118.583C107.214 121.231 105.522 123.18 103.022 123.99C106.553 124.653 109.053 126.933 109.053 130.501ZM91.9133 113.655V123.329H99.2324C102.763 123.329 105.154 121.564 105.154 118.585C105.154 115.605 102.911 113.655 99.6368 113.655H91.9133ZM106.994 130.501C106.994 127.08 104.198 124.983 99.9681 124.983H91.9133V136.091H100.115C104.051 136.091 106.994 133.737 106.994 130.501Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.826 136.201V137.745H129.429C127.553 137.745 126.413 136.605 126.413 134.655V132.375C125.457 135.979 122.33 138.112 118.578 138.112C114.643 138.112 111.848 135.832 111.848 131.933C111.848 128.329 114.202 125.828 119.167 125.828H121.815C125.015 125.828 126.191 124.872 126.191 123.069C126.191 120.385 123.984 118.766 120.748 118.766C117.29 118.766 114.862 120.605 114.532 124.062H112.62C112.988 119.648 116.078 117.184 120.749 117.184C125.42 117.184 128.142 119.722 128.142 123.473V134.435C128.142 135.575 128.621 136.199 129.687 136.199H130.827L130.826 136.201ZM126.302 125.203H126.265C125.75 126.637 124.279 127.447 121.631 127.447H119.24C115.231 127.447 113.833 129.765 113.833 131.934C113.833 134.252 115.341 136.495 118.835 136.495C122.514 136.495 126.302 134.031 126.302 128.33V125.203Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.45 117.517L137.519 142.97C137.262 143.595 136.673 143.999 135.864 143.999H129.574V142.454H135.826L138.107 136.643L130.529 117.518H132.552L139.026 134.547L145.426 117.518H147.449L147.45 117.517Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.905 115.296C165.905 117.369 164.305 118.544 162.265 118.544H158.299V123.425H157.45V112H162.265C164.305 112 165.905 113.224 165.905 115.297V115.296ZM164.991 115.296C164.991 113.745 163.848 112.733 162.086 112.733H158.299V117.809H162.086C163.848 117.809 164.991 116.862 164.991 115.296Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.354 114.446H168.137V116.372H168.17C168.496 115.295 169.312 114.299 170.944 114.299H172.038V115.017H170.748C169.182 115.017 168.17 116.176 168.17 118.362V123.422H167.354V114.445V114.446Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M172.086 118.935C172.086 115.997 174.029 114.299 176.427 114.299C178.825 114.299 180.768 115.997 180.768 118.935C180.768 121.873 178.825 123.569 176.427 123.569C174.029 123.569 172.086 121.871 172.086 118.935ZM179.904 118.935C179.904 116.454 178.387 115.017 176.428 115C174.47 114.985 172.952 116.454 172.952 118.935C172.952 121.416 174.47 122.885 176.428 122.868C178.387 122.852 179.904 121.415 179.904 118.935Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_590_18258",
    x1: 59.9312,
    y1: 44.4463,
    x2: 59.9312,
    y2: 90.5303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_590_18258",
    x1: 87.8516,
    y1: 27.6207,
    x2: 41.7676,
    y2: 27.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_590_18258",
    x1: 104.678,
    y1: 55.5489,
    x2: 104.678,
    y2: 9.46484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_590_18258",
    x1: 76.75,
    y1: 72.3746,
    x2: 122.834,
    y2: 72.3746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocbuyLogo);
export default __webpack_public_path__ + "static/media/docbuy-logo.f4a7ee8d4b67fa2421e12f665ee8c749.svg";
export { ForwardRef as ReactComponent };